// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_createQuietSeller(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["QuietSellerCreated"]);
}

let variablesConverter = {"priceRangeInput":{"minPrice":{"b":""},"maxPrice":{"b":""}},"createQuietSellerInput":{"price":{"r":"propertyPriceInput"},"location":{"r":"propertyLocationInput"},"images":{"r":"attachmentV5Input"},"files":{"r":"attachmentV5Input"},"contact":{"r":"createClientContactInput"},"attributes":{"r":"forSalePropertyAttributesInput"}},"attachmentV5Input":{},"singleFamilyAttributesInput":{},"propertyLocationInput":{},"lotAttributesInput":{},"exactPriceInput":{"price":{"b":""}},"condoAttributesInput":{},"propertyPriceInput":{"priceRange":{"r":"priceRangeInput"},"exactPrice":{"r":"exactPriceInput"}},"multiUnitAttributesInput":{},"forSalePropertyAttributesInput":{"singleFamily":{"r":"singleFamilyAttributesInput"},"multiUnit":{"r":"multiUnitAttributesInput"},"lot":{"r":"lotAttributesInput"},"condo":{"r":"condoAttributesInput"}},"createClientContactInput":{"email":{"b":""}},"__root":{"input":{"r":"createQuietSellerInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"createQuietSeller":{"u":"response_createQuietSeller"}}};

let wrapResponseConverterMap = {
  response_createQuietSeller: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"createQuietSeller":{"u":"response_createQuietSeller"}}};

let responseConverterMap = {
  response_createQuietSeller: unwrap_response_createQuietSeller
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function lotSizeUnit_decode($$enum) {
  if ($$enum === "ACRE" || $$enum === "SQ_FT") {
    return $$enum;
  }
}

let lotSizeUnit_fromString = lotSizeUnit_decode;

function quietPropertyPrivacy_decode($$enum) {
  if ($$enum === "ANONYMOUS" || $$enum === "NORMAL" || $$enum === "HIDDEN") {
    return $$enum;
  }
}

let quietPropertyPrivacy_fromString = quietPropertyPrivacy_decode;

let Utils = {
  lotSizeUnit_decode: lotSizeUnit_decode,
  lotSizeUnit_fromString: lotSizeUnit_fromString,
  quietPropertyPrivacy_decode: quietPropertyPrivacy_decode,
  quietPropertyPrivacy_fromString: quietPropertyPrivacy_fromString
};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateQuietSellerFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createQuietSeller",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "QuietSellerCreated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateQuietSellerFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createQuietSeller",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "QuietSellerCreated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cd61869c866637fa7db81922b6581e80",
    "id": null,
    "metadata": {},
    "name": "CreateQuietSellerFormMutation",
    "operationKind": "mutation",
    "text": "mutation CreateQuietSellerFormMutation(\n  $input: CreateQuietSellerInput!\n) {\n  createQuietSeller(input: $input) {\n    __typename\n    ... on QuietSellerCreated {\n      client {\n        __typename\n        id\n        nodeId\n      }\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_createQuietSeller = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_createQuietSeller = unwrap_response_createQuietSeller;
exports.wrap_response_createQuietSeller = wrap_response_createQuietSeller;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
